import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import bgImg from '../Images/about-dr-jigar-gor.webp'
import Breadcrumb from "../Components/Breadcrumb";
import drImg from '../Images/dr-jigar-gor.webp'
import { certificates, education } from "../Data";
import Youtube from "../Components/Youtube";
import Stats from "../Components/Stats";
import Gallery from "../Components/Gallery";
import Testimonials from "../Components/Testimonials";
import Cta from "../Components/Cta";
import topRightDesign from '../Images/intro-top-right.png'
import bottomRightDesign from '../Images/intro-bottom-right.png'
import AboutPageSchema from "../Schema/AboutPageSchema";
import PersonSchema from "../Schema/PersonSchema";
import MedicalClinicSchema from "../Schema/MedicalClinicSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const About=()=>{
    useEffect(() => {
        document.title =
          "Dr. Jigar Gor | Best Ayurvedic Doctor & Clinic in Bhuj";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Looking for the best doctor for Agnikarma, Panchkarma, Skin & Hair care treatment in Bhuj ? Dr. Jigar Gor will help you with authentic Ayurvedic treatment."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://msayurved.com/about-us");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Dr. Jigar Gor | Best Ayurvedic Doctor & Clinic in Bhuj"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Looking for the best doctor for Agnikarma, Panchkarma, Skin & Hair care treatment in Bhuj ? Dr. Jigar Gor will help you with authentic Ayurvedic treatment."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://msayurved.com/about-us");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://msayurved.com/Images/about.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Dr. Jigar Gor | Best Ayurvedic Doctor & Clinic in Bhuj"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Looking for the best doctor for Agnikarma, Panchkarma, Skin & Hair care treatment in Bhuj ? Dr. Jigar Gor will help you with authentic Ayurvedic treatment."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://msayurved.com/Images/about.webp"
        );
      }
      }, []);

  const [startCount, setStartCount] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setStartCount(true);
  }, 2500);

  return () => clearTimeout(timer);
}, []);
    
const statContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 1.2,
    },
  },
};

const statItem = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -60,
    scale: 0.97,
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 1.4,
      ease: "easeOut",
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2,
    },
  },
};


const gridContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 35,
    scale: 0.96,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

 const galleryContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const imageCard = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "About Dr. Jigar Gor",
      url: "https://msayurved.com/about-us"
    },
  ];
    return(
        <>

        <AboutPageSchema />
  <PersonSchema />
  <MedicalClinicSchema />
  <BreadcrumbSchema items={breadcrumbItems} />
  
        {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="About Dr. Jigar Gor "
        bgImage={bgImg}
        />

        {/**ABOUT THE DR. SECTION */}
        <motion.section
      className="about-section"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
    >
          <img
    src={topRightDesign}
    alt="About Dr. Jigar Gor"
    className="welcome-design welcome-design-top"
  />

  {/* BOTTOM RIGHT DESIGN */}
  <img
    src={bottomRightDesign}
    alt="About Dr. Jigar Gor"
    className="welcome-design welcome-design-bottom"
  />
  <div className="container">
      {/* LEFT IMAGE */}

      <motion.div
        className="about-left"
        variants={fadeLeft}
      >
        <motion.img
          src={drImg}
          alt="Dr. Jigar Gor"
          animate={{
            y: [0, -8, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          whileHover={{
            scale: 1.02,
          }}
        />
      </motion.div>

      {/* RIGHT CONTENT */}

      <motion.div
        className="about-right"
        variants={staggerContainer}
      >
        <motion.p
          className="section-subheading"
          variants={fadeUp}
        >
          About the Doctor
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          About Dr. Jigar Gor
        </motion.h2>

        <motion.p
          className="special-text"
          variants={fadeUp}
        >
          [ BAMS, DYA, PGPP, PGDEMS ] - Ayurveda Consultant
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Dr. Jigar Gor is a distinguished Ayurvedic Consultant
          and Panchakarma Physician with nearly two decades of
          clinical expertise. Since 2007, he has served as the
          founder and Chief Medical Director of "Dr. Jigar Gor's Ayurveda Center," a
          premier multi-specialty facility in Bhuj, Kutch,
          Gujarat. Dr. Gor completed his rigorous clinical
          training under the revered Vaidyacharya, Vd. Shree
          Samir Jamadagni in Pune, Maharashtra, embedded in the
          traditional Guru-Shishya Parampara. This intensive
          foundational mentorship deeply enriched his diagnostic
          acumen and therapeutic expertise in classical
          Ayurvedic medicine.

          Leveraging his extensive practice, Dr. Gor has
          successfully developed proprietary Ayurvedic
          formulations recognized for their high therapeutic
          efficacy and quality. An active participant in the 2nd
          World Ayurveda Congress, he maintains professional
          affiliations with prestigious medical bodies,
          including Ayurveda Vyaspeeth, NIMA, and Ayurveda
          Patrika. Driven by a passion for public health
          awareness, he also authors a dedicated healthcare
          column for the monthly publication "O’Jeevan" and
          frequently contributes authoritative articles to
          leading newspapers.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Extending his professional scope to community welfare,
          Dr. Gor routinely spearheads philanthropic initiatives,
          organizing complimentary medical camps and public
          health lectures. Beyond his clinical responsibilities,
          he maintains a deep connection to nature and
          photography, which directly informs his holistic
          outlook on lifestyle medicine. Through a
          patient-centric approach and a steadfast dedication to
          the clinical advancement of Ayurveda, Dr. Jigar Gor
          continues to set a benchmark for healthcare excellence
          and community service.
        </motion.p>

        {/* STATS */}

        <motion.div
          className="hero-stats"
          variants={statContainer}
         onAnimationComplete={() => setStartCount(true)}
        >
          <motion.div
            className="hero-stat"
            variants={statItem}
          >
            <h3>
              {startCount && (
                <CountUp
                  end={19}
                  duration={3}
                />
              )}
              +
            </h3>

            <p>Years of Experience</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statItem}
          >
            <h3>
              {startCount && (
                <CountUp
                  end={25000}
                  separator=","
                  duration={3}
                />
              )}
              +
            </h3>

            <p>Patients Treated</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statItem}
          >
            <h3>
              {startCount && (
                <CountUp
                  end={100}
                  duration={3}
                />
              )}
              %
            </h3>

            <p>Ayurvedic Treatments</p>
          </motion.div>

          <motion.div
            className="hero-stat"
            variants={statItem}
          >
            <h3>
              {startCount && (
                <CountUp
                  end={4.9}
                  decimals={1}
                  duration={3}
                />
              )}
              /5
            </h3>

            <p>Google Rating</p>
          </motion.div>
        </motion.div>
      </motion.div>
      </div>
    </motion.section>

    {/**EDUCATION QUALIFICATION SECTION */}
    <section className="education-section">
  <div className="container">
    <motion.p
      className="section-subheading"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.2,
      }}
      variants={fadeUp}
    >
      Academics
    </motion.p>

    <motion.h2
      className="section-heading"
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.2,
      }}
      variants={fadeUp}
    >
      Education Qualification
    </motion.h2>

    <motion.div
      className="education-grid"
      variants={gridContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
    >
      {education.map((item, i) => (
        <motion.div
          key={i}
          className="facility-card"
          variants={cardVariant}
          whileHover={{
            y: -5,
          }}
          transition={{
            duration: 0.4,
          }}
        >
          <motion.div
            className="facility-icon"
          >
            <img
              src={item.icon}
              alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
            />
          </motion.div>

          <h3 className="card-heading">
            {item.title}
          </h3>

          <p className="section-text">
            {item.desc}
          </p>
        </motion.div>
      ))}
    </motion.div>
  </div>
</section>

    {/**CERTIFICATES SECTION */}
   <section className="certificates-section container">
  <motion.p
    className="section-subheading"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={fadeUp}
  >
    Inside Our Centre
  </motion.p>

  <motion.h2
    className="section-heading"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={fadeUp}
  >
    A glimpse into our healing spaces and amenities.
  </motion.h2>

  <motion.div
    className="certificates-grid"
    variants={galleryContainer}
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >
    {certificates.map((item, i) => (
      <motion.div
        key={i}
        className="certificate-card"
        variants={imageCard}
      >
        <motion.img
          src={item.img}
          alt={`A glimpse into our healing spaces and amenities. ${i + 1} | Dr. Jigar Gor's Ayurveda`}
          whileHover={{
            scale: 1.03,
          }}
          transition={{
            duration: 0.6,
          }}
        />
      </motion.div>
    ))}
  </motion.div>
</section>

    {/**YOUTUBE SECTION */}
    <Youtube
    showAll={true}
    />
    <div className="margin-div"></div>
    {/**STATS SECTION */}
    <Stats />

    {/**GALLERY-SECTION */}
    <Gallery />

    {/**TESTIMONIALS SECTION */}
    <Testimonials />

             <div className="margin-div"></div>
    {/**CTA SECTION */}
    <Cta />
        </>
    )
}
export default About;